module.exports = __webpack_public_path__ + "static/media/facebook.af494846.svg";